import { render, staticRenderFns } from "./footer_culinary.vue?vue&type=template&id=5167d74d&"
import script from "./footer_culinary.vue?vue&type=script&lang=js&"
export * from "./footer_culinary.vue?vue&type=script&lang=js&"
import style0 from "./footer_culinary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports